export default "__VITE_ASSET__C2dvSdI7__"